import React, { useMemo, useState } from 'react';
import { ChatMessage as ChatMessageType } from '../../types';
import { Loader2, Copy, Check } from 'lucide-react';

interface ChatMessageProps {
  message: ChatMessageType;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.role === 'user';
  const isAssistant = message.role === 'assistant';
  const [copied, setCopied] = useState(false);

  const isCopyable = useMemo(() => {
    if (!isAssistant || message.isLoading) {
      return false;
    }

    const content = message.content || '';
    return (
      content.includes('[DATOS CONSULTADOS]') ||
      content.includes('Estado:') ||
      content.length > 220
    );
  }, [isAssistant, message]);

  const handleCopy = async () => {
    if (!navigator?.clipboard || !message.content) return;
    try {
      await navigator.clipboard.writeText(message.content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      // Error al copiar el mensaje
    }
  };

  return (
    <div
      className={`flex w-full mb-4 ${
        isUser ? 'justify-end' : 'justify-start'
      }`}
    >
      <div
        className={`relative max-w-[80%] rounded-lg px-4 py-2 ${
          isUser
            ? 'bg-primary-600 text-white'
            : 'bg-gray-100 text-gray-900'
        } ${isCopyable ? 'pr-12' : ''}`}
      >
        {message.isLoading ? (
          <div className="flex items-center space-x-2">
            <Loader2 className="h-4 w-4 animate-spin" />
            <span className="text-sm">Escribiendo...</span>
          </div>
        ) : (
          <p className="text-sm whitespace-pre-wrap">{message.content}</p>
        )}
        {isCopyable && (
          <button
            type="button"
            onClick={handleCopy}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 transition-colors cursor-pointer"
            aria-label="Copiar mensaje"
          >
            {copied ? (
              <Check className="h-4 w-4 text-emerald-500" />
            ) : (
              <Copy className="h-4 w-4" />
            )}
          </button>
        )}
        <span
          className={`text-xs mt-1 block ${
            isUser ? 'text-primary-200' : 'text-gray-500'
          }`}
        >
          {new Date(message.timestamp).toLocaleTimeString('es-ES', {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </span>
      </div>
    </div>
  );
};

export default ChatMessage;

